var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.err.length)?_c('div',_vm._l((_vm.err),function(error){return _c('div',{staticClass:"alert alert-danger d-flex justify-content-between",attrs:{"role":"alert"}},[_c('span',{domProps:{"innerHTML":_vm._s(error)}}),_vm._v(" "),_c('button',{staticClass:"btn-close",attrs:{"type":"button"},on:{"click":_vm.dismiss}})])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }